export default __webpack_public_path__ + "static/media/Divyanshu.6a038ecc.jpg";